import React from 'react'
import PropTypes from 'prop-types'
import FieldGlistView from "../../../../fields3/render/glist/glist-view";
import FieldGlistEditable from "../../../../fields3/render/glist/glist-editable";
import FieldProto from "../../../../fields3/proto/field-proto";
import {FieldRenderMethod} from "../../../../fields3/const";
import FieldViewReference from "../../../../fields3/render/view-reference";
import GenericListModule from "../../generic-list-module";
import GlistColumn from "../../manager/columns-manager/column";

const debug = false
// const debug = "ListItemCell"

type Props = {
    module  : GenericListModule,
    column  : GlistColumn,
    data    : any,
    isFirst : boolean,
    isLast  : boolean
}

export type GlistCellContentProps = {
    field       : FieldProto,
    model       : any
    module      : GenericListModule
}

export default class ListItemCell extends React.Component<Props> {

    public field    : FieldProto

    constructor(props:any) {
        super(props)

        this.field = props.module.fields.get(props.column.fieldId)
    }

    onValueChange = (newValue:any) => {
        this.props.module.onFieldValueChanged(this.field, this.props.data, newValue)
    }

    render() {
        const isTitle   = this.props.module.config.titleField === this.props.column.fieldId
        const isSticky  = isTitle && this.props.module.titleSticky

        let content
        if (isTitle && !!this.props.module.renderTitleComponent) {
            const Component = this.props.module.renderTitleComponent
            content = <Component field          = {this.field}
                                 model          = {this.props.data}
                                 module         = {this.props.module}
                                 onChange       = {this.onValueChange}/>

        } else if (this.props.column.component) {

            // Custom render component defined

            content = <this.props.column.component field={this.field} model={this.props.data} module={this.props.module} />

        } else {

            switch (this.props.column.renderMethod) {
                case FieldRenderMethod.VIEW_REFERENCE:
                    content = <FieldViewReference field={this.field} model={this.props.data} />
                    break


                case FieldRenderMethod.GLIST_EDITABLE:
                case "renderInlineEditable":
                case "editable":
                    content = <FieldGlistEditable field={this.field} model={this.props.data} onChange={this.onValueChange} module={this.props.module} />
                    break

                case "renderView":
                case "view":
                case FieldRenderMethod.VIEW:
                case FieldRenderMethod.VIEW_SMALL:
                default:
                    content = <FieldGlistView field={this.field} model={this.props.data} module={this.props.module} />
                    break
            }
            // content = this.field.gList[this.props.column.renderMethod](this.props.data, this.onValueChange, this.props.module)
        }

        const classes = Classes("cell", this.props.column.alignment,  {
            'sticky'        : isSticky,
            'with-group-by' : !!this.props.module.groupBy,
            'is-first'      : this.props.isFirst,
            // @ts-ignore
            [this.props.module.config.titleCellClassName]   : this.props.isFirst,
            'is-last'       : this.props.isLast
        })

        const styles:any = {
            width:this.props.column.width
        }
        if (isSticky) {
            styles.left = this.props.module.skin.paddingLeft
        }

        debug && console.log(debug, 'render', isTitle, !!this.props.module.renderTitleComponent)

        return (
            <div className={classes} style={styles}>
                {content}
                {isSticky && <div className="sticky-shadow-emitter"/>}
            </div>
        )
    }
}

